import React from 'react';
import { Link } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { OpeningStatement } from '../components/OpeningStatement';
import { AccessFallacy } from '../components/AccessFallacy';
import { LogoScroll } from '../components/LogoScroll';
import { GeneticAI } from '../components/GeneticAI';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-2298">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2299">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2300">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2301">
            <Link to="/" data-id="element-2302">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2303" />
            </Link>
            <Navigation data-id="element-2304" />
          </div>
        </div>
      </header>

      <main data-id="element-2305">
        <Hero data-id="element-2306" />
        <OpeningStatement data-id="element-2307" />
        <AccessFallacy data-id="element-2308" />
        <LogoScroll data-id="element-2309" />
        <GeneticAI data-id="element-2310" />
        <CTASection data-id="element-2311" />
      </main>

      <Footer data-id="element-2312" />
    </div>;
}